import React, { Component } from 'react';
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';
import ChatLi from "./ChatLi";

@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class ActiveChats extends Component {

    constructor(props) {
        super(props);
        this.state={
            clicked:true
        }
        this.handleOnClick=this.handleOnClick.bind(this);
    }

    handleOnClick(){
        this.setState({
            clicked:!this.state.clicked
        });
    }
    componentWillUnmount() {
        this.props.dispatch({
            type: 'SET_DOCUMENT_TITLE',
            data: this.props.chatprop.document_default_title
        });
    }

    componentDidMount() {
        this.props.dispatch({
            type: 'SET_DOCUMENT_TITLE',
            data: "HelperVia | Active Chats"
        });
    }

    render() {
        const { t } = this.props;

                var chatData=this.props.chatprop.activeChats.filter(chat=>chat.status=='A' && chat.supervised!=1);

                return (


                    <React.Fragment>
                            <div className="chat-list-header" onClick={() => this.handleOnClick()}>
                                <span className={"chat-list-header-arrow "+(this.state.clicked==false ? "closed-arrow" : "")}>
                                    <div>
                                        <svg width="20px" fill="#61657b" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                            <g >
                                                <path stroke-width="1" stroke="#61657b" d="M 4 6.2910156 L 3.2910156 7 L 3.6464844 7.3535156 L 10 13.708984 L 16.353516 7.3535156 L 16.708984 7 L 16 6.2910156 L 15.646484 6.6464844 L 10 12.291016 L 4.3535156 6.6464844 L 4 6.2910156 z " />
                                            </g>
                                        </svg>

                                    </div>
                                </span>
                                <span className="chat-list-header-name ">
                                    Active Chats (<span className="chat-list-header-count">{this.props.chatCount}</span>)
                                </span>

                            </div>
                            <div className={"chat-list-container "+(this.state.clicked==false ? "chat-list-container-closed" : "")}>
                                {Object.keys(chatData).sort((a, b) => a.user_closed > b.user_closed ? -1:1).map(chat => {
                                    return <ChatLi closeChat={this.props.closeChat} data={chatData[chat]} selected_id={this.props.selected_id}/>
                                })}
                            </div>
                    </React.Fragment>


                )


    }
}

export default withTranslation()(ActiveChats);
